<div class="drawer-backdrop" *ngIf="open" (click)="onBackdropClick()"></div>
<div class="drawer-panel" [class.open]="open" [style.width]="width">
  <div class="drawer-header">
    <div class="drawer-header-content">
      <ng-content select="[drawer-header]"></ng-content>
    </div>
    <button type="button" class="drawer-close" (click)="close()" aria-label="Close">
      <i class="fa-solid fa-xmark" aria-hidden="true"></i>
    </button>
  </div>

  <div class="drawer-body">
    <ng-content></ng-content>
  </div>

  <div class="drawer-footer">
    <ng-content select="[drawer-footer]"></ng-content>
  </div>
</div>

